import Button from '@berlitz/button'
import { Col } from 'react-styled-flexboxgrid'
import styled, { css } from 'styled-components'

import { LabelProp } from './interface'

export const Container = styled.div`
  margin-top: ${({ theme }) => theme.space.lg};
`

export const StyledCol = styled(Col)`
  padding-left: 0;
`

export const ProfileLabel = styled.p`
  margin: 0;
  font-weight: 500;
`

export const ProfileValue = styled.p`
  margin: 0;
  margin-top: ${({ theme }) => theme.space.xs};
  margin-bottom: ${({ theme }) => theme.space.xs};
`

export const Message = styled.div`
  margin-left: 46px;
  margin-top: 16px;
`

export const StyledButton = styled(Button)`
  padding: ${({ theme }) => `${theme.space.xs} ${theme.space.lg}`};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-top: ${({ theme }) => theme.space.lg};
  margin-left: auto;
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
  }
`

export const StyledButtonCol = styled(Col)`
  width: 100%;
  padding-left: 0;
  padding-right: 0;
  div {
    display: flex;
  }
`

export const Label = styled.div<LabelProp>`
  display: flex;
  align-items: center;
  width: max-content;
  font-size: ${({ theme }) => theme.fontSize.xxs};

  ${({ theme, named }) =>
    named &&
    css`
      font-weight: ${theme.fontWeight.bold};
    `}
`

export const Box = styled.div``

export const ErrorWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  padding: ${({ theme }) => theme.space.lg};
  border-radius: 3px;

  &.error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .select-loader {
    display: flex;

    div:first-child {
      margin-right: ${({ theme }) => theme.space.md};
    }
  }
`

export const NoPaddingCol = styled(Col)`
  padding-left: 0;
  padding-right: 0;
`
